import React from "react";
import { useGlobalContext } from "../../utils/globalContext";
import URI from "urijs";
import { Link } from "react-router-dom";
import { ArrowRight } from "@speedoc/design-assets/build/icons/index.js";
import { useMediaQuery } from "react-responsive";

const NewService = ({ content }) => {
  const { Trans } = useGlobalContext();
  const isMobile = useMediaQuery({ query: "(max-width: 992px)" });

  const { title, linkText, linkTextMobile, linkUrl, linkUrlMobile } = content;
  return (
    <div id="newService">
      <hr />
      <div className="contentBox">
        <h1 className={`title ${linkUrl ? "" : "no-margin"}`}>
          <Trans>{title}</Trans>
        </h1>
        {linkText && linkUrl && (
          <Link to={new URI(isMobile ? linkUrlMobile || linkUrl : linkUrl).path()} className="link">
            {isMobile ? linkTextMobile || linkText : linkText}
            <ArrowRight />
          </Link>
        )}
      </div>
    </div>
  );
};

export default NewService;
